var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_1695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.75 12.75H16.25C14.875 12.75 13.75 13.875 13.75 15.25V32.75C13.75 34.125 14.875 35.25 16.25 35.25H33.75C35.125 35.25 36.25 34.125 36.25 32.75V15.25C36.25 13.875 35.125 12.75 33.75 12.75ZM26.25 30.25H20C19.3125 30.25 18.75 29.6875 18.75 29C18.75 28.3125 19.3125 27.75 20 27.75H26.25C26.9375 27.75 27.5 28.3125 27.5 29C27.5 29.6875 26.9375 30.25 26.25 30.25ZM30 25.25H20C19.3125 25.25 18.75 24.6875 18.75 24C18.75 23.3125 19.3125 22.75 20 22.75H30C30.6875 22.75 31.25 23.3125 31.25 24C31.25 24.6875 30.6875 25.25 30 25.25ZM30 20.25H20C19.3125 20.25 18.75 19.6875 18.75 19C18.75 18.3125 19.3125 17.75 20 17.75H30C30.6875 17.75 31.25 18.3125 31.25 19C31.25 19.6875 30.6875 20.25 30 20.25Z",
    fill: "#5177FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_1695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.7aa2a9ee87596b55bcf465aee7c3bc8b.svg";
export { ForwardRef as ReactComponent };